// ======================================================================
// File Name       : ContentDrillDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as ContentAction from '../../actions/content/ContentAction';
import { deleteDrill, getDrillDetail } from '../../actions/content/ContentDrillAction';
import ContentDrillDetail from '../../components/content/ContentDrillDetail';
import DialogConfirm from '../../components/DialogConfirm';
import Header from '../../components/Header';
import { DRILL_TYPE_ID } from '../../constants/ContentConstant';
import { CONTENT_DRILL_EDIT } from '../../constants/FunctionConstants';
import { IS_SHOW_MENU_DEVELOP_FEATURE_51 } from '../../constants/index';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { CONTENT, CONTENT_DRILL, CONTENT_DRILL_LIST } from '../../constants/PathConstants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import { getQuestionList } from '../../utils/ContentUtils';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentDrillDetailContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      drillDetailInfo: null,
    };
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteOk = this.onDeleteOk.bind(this);
  }

  /**
   * Life cycle function
   */
  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const drillId = match.params.id;
      this.props.dispatch(getDrillDetail(drillId)).then((response) => {
        let questionList = [];
        if (response && response.drillInfo && response.drillInfo.drillGroupArray) {
          questionList = getQuestionList(response.drillInfo.drillGroupArray);
        }
        this.props.dispatch(ContentAction.getQuestionListDrillDetail(questionList));
      });
    }
  }

  /**
   * Life cycle function
   */
  componentWillReceiveProps(nextProps) {
    const { content, match } = nextProps;
    if (match.params.id) {
      const { drillDetailInfo } = content;
      if (drillDetailInfo) {
        this.setState({
          drillDetailInfo,
        });
      } else {
        this.props.history.push(CONTENT_DRILL_LIST);
      }
    } else {
      this.props.history.push(CONTENT_DRILL_LIST);
    }
  }

  componentWillUnmount() {
    this.setState({
      drillDetailInfo: null,
    });
    this.props.dispatch(ContentAction.resetDialogQuestion());
  }

  /**
   * Open delete confirm dialog
   * @param {*} mdContent
   * @param {*} mdSize
   */
  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModal: true });
  }

  /**
   * Event click button cancel of delete confirm dialog
   */
  onDeleteCancel() {
    this.setState({ showModal: false });
  }

  /**
   * Event click button ok of delete confirm dialog
   */
  onDeleteOk() {
    this.setState({ showModal: false });
    const { history } = this.props;
    this.props.dispatch(deleteDrill(this.state.drillDetailInfo.drillSecernId)).then(() => {
     // Go to drill list
      history.push(CONTENT_DRILL_LIST);
    });
  }



  /**
   * Render function of component
   */
  render() {
    const editPath = this.state.drillDetailInfo ? `/${CONTENT}/${CONTENT_DRILL}/${this.state.drillDetailInfo.drillSecernId}/edit` : '';
    const canEditDelete = canAccessRoute(CONTENT_DRILL_EDIT);
    const showAdaptive = (IS_SHOW_MENU_DEVELOP_FEATURE_51 || (this.state.drillDetailInfo && this.state.drillDetailInfo.drillKind !== DRILL_TYPE_ID.ADAPTIVE));
    const showEditBtn = this.state.drillDetailInfo &&
                !this.state.drillDetailInfo.dataAffiliationType &&
                canEditDelete && showAdaptive;
    const { questionDrillList, questionDrillListArr } = this.props.content;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DRILL_LIST}
          text="ドリル一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="ドリルの詳細" />
        {this.state.drillDetailInfo ?
          <ContentDrillDetail
            drillDetailInfo={this.state.drillDetailInfo}
            isDetail
            questionDrillList={questionDrillList}
            questionDrillListArr={questionDrillListArr}
            markRule={this.state.drillDetailInfo.markRule}
          /> : null}
        <Form.Group className="margin-top-20 text-center form-info">
          <Col sm={12}>
            {showEditBtn ?
                  <Link
                    className="btn btn-primary margin-10 btn-96"
                    role="button"
                    to={canEditDelete ? editPath : '#'}
                  >
                    編集
                  </Link> : null}
            {this.state.drillDetailInfo &&
                !this.state.drillDetailInfo.dataAffiliationType &&
                canEditDelete ?
                  <Button
                    variant="primary"
                    className="margin-10 btn-96"
                    onClick={this.openDeleteConfirmDialog.bind(this, MessageTemplate.MSG_DEL_DRILL, null)}
                    disabled={!canEditDelete}
                  >
                  削除
                </Button> : null}
          </Col>
        </Form.Group>
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onDeleteCancel}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onDeleteOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...{ content: state.content } });

export default connect(mapStateToProps)(ContentDrillDetailContainer);
